import React from 'react';

// Shared consent text for both the modal and settings page. Keeping it in
// one place ensures the audit trail always matches what the user actually
// saw.
//
// v4 — 2026-02-xx rev: FCC Oct 2026 (Order FCC-CIRC 2609-05) category-scoped
// STOP. Reply STOP no longer stops all SMS globally; it stops the category
// of the message replied to. This string MUST match
// `auth_routes.CONSENT_TEXT_V4` character-for-character — the backend uses an
// exact-string comparison to stamp `text_version: "v4"` on the consent record
// for Twilio A2P audit + FCC compliance evidence. Edits here require an edit
// there in the same deploy.
export const SMS_CONSENT_TEXT_VERSION = 'v4';
export const SMS_CONSENT_TEXT =
  'I agree to receive text messages (SMS) from LISTING AiGENT, including security ' +
  'verification codes, listing details, and appointment reminders, at the number I ' +
  'provide. Msg & data rates may apply. Msg frequency varies. Reply STOP to any text ' +
  'to unsubscribe from that category of messages; HELP for help. ' +
  'View SMS Policy. View Privacy Policy.';

export function ConsentBlock() {
  return (
    <>
      I agree to receive text messages (SMS) from LISTING AiGENT, including security
      verification codes, listing details, and appointment reminders, at the number I provide.
      Msg &amp; data rates may apply. Msg frequency varies.
      Reply <code className="px-1 rounded bg-brand-cream-dark text-brand-green text-xs">STOP</code> to
      any text to unsubscribe from that category of messages;
      <code className="px-1 rounded bg-brand-cream-dark text-brand-green text-xs"> HELP</code> for help.{' '}
      <a href="/terms#s8" target="_blank" rel="noreferrer"
        className="underline text-brand-green hover:text-brand-green-dark">View SMS Policy</a>.{' '}
      <a href="/privacy" target="_blank" rel="noreferrer"
        className="underline text-brand-green hover:text-brand-green-dark">View Privacy Policy</a>.
    </>
  );
}
